var dFlipLocation = "/includes/flipbook/";

(function($) {





	$.cookie.json = true;
	// ======================================
	// Config
	// ======================================
	window.C = {
		iconPath: 	'img/icons/',
		iconExt: 	'.svg',
		iconRegExp: /[ ]*i-[a-z0-9\-]+[ ]*/g,
		homeHeaderImagesInterval: 	3750,
		sliderInterval: 			7500,
		mobileThreshold: 			640+16
	}
	window.D = {
		iconPath: 	'img/icons/',
		iconExt: 	'.svg',
		iconRegExp: /[ ]*i-[a-z0-9\-]+[ ]*/g,
		footerImagesInterval: 	3750,
		sliderInterval: 			7500,
		mobileThreshold: 			640+16
	}

	
	$('#dfb5ab4bc4b30c90Container').click(function()
	{
		var option_dfb5ab4bc4b30c90Container = {
			webgl: true,
			height: 750, 
			duration: 800, 
			soundEnable: true,
			scrollWheel: true,
			backgroundColor: "inherit",
			direction: DFLIP.DIRECTION.LTR,
			enableDownload: true
		};
		$("#catalogue").hide();
		$("#flipbookContainer").show().flipBook("/pdfs/BROCHURE-CELESTRA-1.0.pdf", option_dfb5ab4bc4b30c90Container);
	});



	setTimeout(function()
	{
		$('#home-header .trame').height($('#video-container video').height());
		$('#home-header .menu-home').height($('#video-container video').height());


		if($(".share-twitter").is('a'))
			$(".share-twitter").sharelink("twitter");
		if($(".share-facebook").is('a'))
			$(".share-facebook").sharelink("facebook");
		if($(".share-linkedin").is('a'))
			$(".share-linkedin").sharelink("linkedin");



	}, 500);
	
	$(window).resize(function()
	{
		$('#home-header .menu-home').height($('#video-container video').height());
		$('#home-header .trame').height($('#video-container video').height());

	});

	$(document).ready(function()
	{
		$('#menu-fixe').sticky({ topSpacing: 20, bottomSpacing: 0,  className:"sticky" });
		$('#menu-fixe li>a').click(function(e)
		{
			e.stopPropagation();
			e.preventDefault();
			$([document.documentElement, document.body]).animate({
				scrollTop: ($($(this).attr('href')).offset().top - $('#menu-fixe').height())
			}, 1500);
		});



		$('#sidebar .icones .onglets #reseaux').hover(
			function() 
			{
				$(this).parents('.icones').find('.reseaux').show();
				//$(this).parents('.icones').find('.reseaux').css('height', 'auto');
				$(this).parents('.icones').find('.reseaux').animate(
					{
						height: '40px',
						padding: '0px'
					},
					{
						duration: 300
					}
				);
			},
			function() 
			{

			}
		);
		$('#sidebar .icones .onglets #reseaux').hover(
			function() 
			{
				
			},
			function() 
			{
				/*
				$(this).parents('.icones').find('.reseaux').animate(
					{
						height: '0px',
						padding: '0px'
					},
					{
						duration: 500,
						complete: function()
						{
							$(this).hide();
						}
					}
				);
				*/
			}
		);




		$('[data-remodal-id=form-partage-par-mail]').find('input.submit').click(function(e)
		{
			e.preventDefault();
			e.stopPropagation();
			var form = $(this).parents('.partage-par-mail');
			var merci = $(this).parents('.block-content').find('.merci');
			var erreur = false;

			form.show();
			if(!merci.hasClass('hide'))
				merci.addClass('hide');

			form.find('input').removeClass("alert");
			if(form.find('input[name=nom]').val() == "")
			{
				form.find('input[name=nom]').addClass("alert");
				erreur = true;
			}
			if(form.find('input[name=prenom]').val() == "")
			{
				form.find('input[name=prenom]').addClass("alert");
				erreur = true;
			}
			if(form.find('textarea[name=destinataires]').val() == "")
			{
				form.find('textarea[name=destinataires]').addClass("alert");
				erreur = true;
			}
			if(form.find('textarea[name=message]').val() == "")
			{
				form.find('textarea[name=message]').addClass("alert");
				erreur = true;
			}
			if(!erreur)
			{
				datas = {};
				datas.prenom = form.find('input[name=prenom]').val();
				datas.nom = form.find('input[name=nom]').val();
				datas.destinataires = form.find('textarea[name=destinataires]').val();
				datas.message = form.find('textarea[name=message]').val();
				datas.programme = form.parents('.block-content').find('.resume').text();

				$.ajax({
					url: '/services/partage.php',
					type: 'POST',
					dataType: 'json',
					data: datas,
					success: function(retour)
					{
						form.hide();
						merci.removeClass('hide');
					},
					error: function(e)
					{
						console.log("error inscription");
					}
				});
			}
			else
				console.log('erreur');
		});


		$('#sidebar.prog .tab-pane .submit, #sidebar.prog .sessions li.date').click(function()
		{
			var inst = $('[data-remodal-id=form-intra-sur-mesure]').remodal();
			var datas = {};

			if($(this).parents('.tab-pane').attr('id') != undefined)
			{
				var type = $(this).parents('.tab-pane').attr('id');
				if(type == "intra")
				{
					$('[data-remodal-id=form-intra-sur-mesure]').find('.resume').html('Demande de devis en intra pour "'+$('#page-content >.wrapper >#content >h2 span').text()+'"');
					$('[data-remodal-id=form-intra-sur-mesure]').find('textarea[name=message]').attr('placeholder', "Vous souhaitez ajouter des détails à votre demande ? Vous avez des questions ? Laissez-nous un message.")
				}
				else if(type == "sur-mesure")
				{
					$('[data-remodal-id=form-intra-sur-mesure]').find('.resume').html('Demande de renseignements pour du sur-mesure sur "'+$('#page-content >.wrapper >#content >h2 span').text()+'"');
					$('[data-remodal-id=form-intra-sur-mesure]').find('textarea[name=message]').attr('placeholder', "Laissez-nous un message.")
				}
				
			}
			else
			{
				//c'est un date
				var type = "date";
				datas.prog_id = $(this).parents('#sidebar').data('prog_id');

				datas.f_id = $(this).data('num');
				datas.depart = $(this).data('depart');
				datas.fin = $(this).data('fin');
				$('[data-remodal-id=form-intra-sur-mesure]').find('.resume').html('Demande d\'inscription pour la session du '+datas.depart+' au '+datas.fin+' sur "'+$('#page-content >.wrapper >#content >h2 span').text()+'"');
			}

			$('[data-remodal-id=form-intra-sur-mesure]').find('input.submit').click(function(e)
			{
				e.preventDefault();
				e.stopPropagation();
				var form = $(this).parents('.reservation-form-intra-sur-mesure');
				var merci = $(this).parents('.block-content').find('.merci');
				var erreur = false;

				form.show();
				if(!merci.hasClass('hide'))
					merci.addClass('hide');

				form.find('input').removeClass("alert");
				if(form.find('input[name=nom]').val() == "")
				{
					form.find('input[name=nom]').addClass("alert");
					erreur = true;
				}
				if(form.find('input[name=prenom]').val() == "")
				{
					form.find('input[name=prenom]').addClass("alert");
					erreur = true;
				}
				if(form.find('input[name=tel]').val() == "" && form.find('input[name=email]').val() == "")
				{
					form.find('input[name=tel]').addClass("alert");
					form.find('input[name=email]').addClass("alert");
					erreur = true;
				}
				if(!erreur)
				{
					datas.prenom = form.find('input[name=prenom]').val();
					datas.nom = form.find('input[name=nom]').val();
					datas.email = form.find('input[name=email]').val();
					datas.tel = form.find('input[name=tel]').val();
					datas.message = form.find('textarea[name=message]').val();
					datas.type = type;
					datas.programme = form.parents('.block-content').find('.resume').text();

					inscription(
						datas, 
						function(retour)
						{
							form.hide();
							merci.removeClass('hide');

							/*setTimeout(
								function(){ 
									inst.close();
									form.show();
									merci.addClass('hide');
								}, 
								3000
							);*/
						}
					);
				}
				else
					console.log('erreur');
			});

			inst.open();
		});
	});


	// ======================================
	// Creating SVG icons
	// ======================================
	/*
	test
	*/
	$('i').each(function()  
	{
		var $icon = $(this);
		if($icon.attr('class') != undefined)
		{
			var iconName = $icon.attr('class').match(C.iconRegExp);

			if (iconName) iconName = iconName[0].trim();
			else return;

			var iconURL = C.iconPath + iconName + C.iconExt;

			$.get(iconURL, function(data)
			{
				var $svg = $(data).find('svg');

				$svg.addClass('created-svg');
				$svg.removeAttr('xmlns:a');

				if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width'))
				{
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
				}

				$icon.append($svg);
			}, 'xml');
		}
	});


	$('.ss-menu').hover(
		function()
		{
			$(this).show();
		},
		function()
		{
			$(this).hide();
		}
	);
	//pour le sous menu principal
	$('#main-nav>div.wrapper a').hover(
		function()
		{
			$('.ss-menu').hide();
			if($(this).data('ssmenu') != "")
			{				
				$('.ss-menu#'+$(this).data('ssmenu')).css('top', $('#header').height() + 6 - 20);
				$('.ss-menu#'+$(this).data('ssmenu')).show();

			}
		}
	);

	// ======================================
	// Dropdown Class
	// ======================================
	var Dropdown = function(el, onSelect)
	{
		var _this = this;

		// Variables
		this.$input = $(el);
		this.$onSelect = onSelect;
		this.$dropdown = this.$input.find('.dropdown');
		this.$active = this.$dropdown.find('li.active');
		this.$inputPlaceholder = this.$input.find('.value .placeholder');
		this.$inputText = this.$input.find('.value .input-text');
		this.$inputHidden = this.$input.find('.value .hidden-input');

		// @function
		this.onSelectOption = function()
		{
			var $option = $(this),
				text = $option.text(),
				value = $option.attr('data-value');

			_this.$active.removeClass('active');

			$option.addClass('active');

			_this.setOption(text, value, true);

			if(_this.$onSelect != undefined)
			{
				_this.$onSelect(_this, $option);
			}
		}

		// @function
		this.setOption = function (text, value, hideDropdown)
		{
			_this.$inputPlaceholder.hide();
			_this.$inputText.text(text).show();
			_this.$inputHidden.val(value);

			// remove hover on the select (make the dropdown disappear on click)
			if (hideDropdown) 
			{
				_this.$dropdown.hide();
				setTimeout(function() { _this.$dropdown.attr('style', ''); }, 50);
			}
		}

		// Si on est une page catégorie, on sélectionne dans le "select" la catégorie "active"
		// > juste ajouter la class "active" au "li" dans le dropdown
		if (this.$active.length)
		{
			this.setOption(this.$active.text(), this.$active.attr('data-value'));
		}

		// Event Listeners
		this.$dropdown.find('li').on('click', this.onSelectOption);
		this.$dropdown.find('li.choix').on('click', function()
		{
			/*var fdates = $('#modeleSelectDate').clone();
			var bouton = $(this).parents('.ligneprog').find('.pres1 .button');
			bouton.find('.bt-inscription').hide();
			bouton.append(fdates);

			//il faut rendre inactif les 
			new Dropdown(bouton.find('.js-dropdown-mois'), function(dropdow, option)
			{

			});
			new Dropdown(bouton.find('.js-dropdown-jour'), function(dropdow, option)
			{
				
			});
			fdates.removeClass('hide');*/

			//affichage d'un calendrier

		});
	};

	// Dropdown class instanciation
	$('.js-dropdown-search').each(function() 
	{ 
		new Dropdown(this, function(dropdown, option)
			{
				document.location.href = 'https://'+window.location.hostname + option.data('value')+'.html';
			}
		); 
	});

	$('.js-dropdown').each(function() 
	{ 
		new Dropdown(this); 
	});
	$('.js-dropdown-ligneProg').each(function()
	{
		new Dropdown(this, function(dropdown, $option)
			{
				var _this = dropdown;

				var bouton = $(this).parents('.ligneprog').find('.pres1 .button');
				bouton.find('.bt-inscription').show();

				$($option[0]).parents('.js-dropdown-ligneProg').find('.value .input-text').css('color', '#3396e8');
				$($option[0]).parents('.js-dropdown-ligneProg').find('.value .input-text').css('fontWeight', 'bolder');

				dropdown.$dropdown.show();
				$($option[0]).find('.calendar').datepicker(
				{
					firstDay: 1,
					showOtherMonths: true,
					selectOtherMonths: true,
					altField: "#datepicker",
					closeText: 'Fermer',
					prevText: 'Précédent',
					nextText: 'Suivant',
					currentText: 'Aujourd\'hui',
					monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
					monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
					dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
					dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
					dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
					weekHeader: 'Sem.',
					dateFormat: 'yy-mm-dd',
					minDate: "+5W",
					width:'100%',
					onSelect : function(date, datepicker)
					{
						var ligneProg = $(this).parents('.ligneprog');
						if(!ligneProg.find('.pres1 .button .bt-inscription').hasClass('ajouter'))
							ligneProg.find('.pres1 .button .bt-inscription').trigger('click');

						var d = new Date(date);
						d.setDate(d.getDate() + ($($option[0]).data('nbjours') - 1 ));
						var jour = datepicker.selectedDay;
						var mois = datepicker.selectedMonth + 1;
						var txt = $($option[0]).data('nbjours')+" jours du "+jour+"/"+mois+" au "+d.getDate()+"/"+(d.getMonth() - 1)+" - "+ parseInt($($option[0]).data('prix')) +"€";
						_this.$inputText.text(txt);
						$($option[0]).data('dates_perso', date);

					}
				});

			}
		); 
	});

	// ======================================
	// Home Slider
	// ======================================
	var $slider = $('#home-slider');
	var S = {
		// @variables
		active: 0,
		height: 0,
		nb: 0,
		interval: 0,

		// @elements
		$prev: $slider.find('.navigation.prev'),
		$next: $slider.find('.navigation.next'),
		$wrapper: $slider.find('.slider-wrapper'),
		$slides: $slider.find('.slide'),

		// @function
		init: function() {
			// Variables
			S.height = $slider.innerHeight();
			S.nb = S.$slides.length;

			// Event Listeners
			S.$prev.on('click', S.prev);
			S.$next.on('click', S.next);
			$(window).on('resize', S.onresize);

			// Actions
			S.$slides.eq(S.active).addClass('active');
			S.setAutoplay();
		},

		// @function
		next: function() {
			var n = (S.active + 1)%S.nb;
			S.goTo(n);
			S.setAutoplay();
		},

		// @function
		prev: function() {
			var n = ((S.active - 1)+S.nb)%S.nb;
			S.goTo(n);
			S.setAutoplay();
		},

		// @function
		goTo: function(n) {
			var top = -n*S.height;
			S.$slides.removeClass('active');
			S.$slides.eq(n).addClass('active');
			S.$wrapper.css({'top': top+'px'});
			S.active = n;
		},

		// @function
		onresize: function() {
			S.height = $slider.innerHeight();
			S.goTo(S.active);
		},

		// @function
		setAutoplay: function() {
			window.clearInterval(S.interval);
			S.interval = window.setInterval(S.next, C.sliderInterval);
		}
	};

	S.init();


	// ======================================
	// Home Header Images
	// ======================================
	var $HHimages = $('#home-header .header-images div'),
		HHactive = 0,
		HHlength = $HHimages.length,
		HHloop = function() {
			var n = (HHactive+1)%HHlength;
			$HHimages.removeClass('active');
			$HHimages.eq(n).addClass('active');

			HHactive = n;
		},
		HHinterval = window.setInterval(HHloop, C.homeHeaderImagesInterval);


	// ======================================
	// footer Images
	// ======================================
	var $Fimages = $('#footer .header-images div'),
		Factive = 0,
		Flength = $Fimages.length,
		Floop = function() {
			var n = (Factive+1)%Flength;
			$Fimages.removeClass('active');
			$Fimages.eq(n).addClass('active');

			Factive = n;
		},
		Finterval = window.setInterval(Floop, D.footerImagesInterval);



	// ======================================
	// Footer Accordion
	// ======================================
	var $accordionItems = $('.accordion .accordion-item');

	$accordionItems.on('click', '.title', function(e) {
		var n = $accordionItems.index(e.delegateTarget);
		setAccordionItemActive(n);
	});

	var setAccordionItemActive = function(n) {
		var $item = $accordionItems.eq(n),
			isActive = $item.hasClass('active'),
			classFunction = (isActive) ? 'removeClass' : 'addClass';

		$accordionItems.removeClass('active');
		$item[classFunction]('active');
	}

	setAccordionItemActive(0);


	// ======================================
	// Reorder blocks position on mobile
	// ======================================
	var $content = $('#content'),
		$sidebar = $('#sidebar'),
		$pageContent = $('#page-content .wrapper'),
		$window = $(window),
		$rightSidebar = $('#content .right-sidebar'),
		pageContentOrder = 'desktop';

	var reorderPageContent = function() {
		var ww = $window.outerWidth();

		if (ww <= C.mobileThreshold && pageContentOrder == 'desktop') {
			// go to => mobile layout
			pageContentOrder = 'mobile';
			$sidebar.appendTo($pageContent);
			$rightSidebar.appendTo($content);
		}
		else if (ww > C.mobileThreshold && pageContentOrder == 'mobile') {
			// go to => desktop layout
			pageContentOrder = 'desktop';
			$sidebar.prependTo($pageContent);
			$rightSidebar.prependTo($content);
		}
	}

	$window.on('resize', reorderPageContent);
	reorderPageContent();



	
	//action sur les boutons contact de la sidebar de droite de la page programme
	$('.right-sidebar .reservation-form-inter .button').click(function()
	{
		var thos = this;
		var form = $(this).parents('.reservation-form-inter');
		//var pres3 = form.parent().find('.pres3');
		var session = form.find('.price-select ul li.active');
	
		var error = false;
		if(form.find('input[name=email]').val() == '')
		{
			form.find('input[name=email]').addClass('alert');
			error = true;
		}
		else
			form.find('input[name=email]').removeClass('alert');

		if(form.find('input[name=tel]').val() == '')
		{
			form.find('input[name=tel]').addClass('alert');
			error = true;
		}
		else
			form.find('input[name=tel]').removeClass('alert');
	
		if(!error)
		{
			var data = {
				email: 		form.find('input[name=email]').val(),
				tel: 		form.find('input[name=tel]').val(),
				prog_id: 	form.find('input[name=prog_id]').val()
			}
			if(session.length > 0)
			{
				data.f_id 	= session.data('f_id');
				data.prix 	= session.data('prix');
				data.depart = session.data('depart');
				data.fin 	= session.data('fin');
			}
			inscription(
				data, 
				function(retour)
				{
					form.find('.button').off();
					form.find('.button span').css('backgroundColor', '#00D96D');
					form.find('.button img.inscription').attr("src", "/img/checked-white.png");
					form.find('.button img.inscription').css('top', '10px');
					form.find('.button .bt-inscription span').text('Ajouté');
					form.find('.price-select').remove();
					form.prepend('<div class="input select price-select"><div class="input-text" style="display: block;">Réservation envoyée</div></div>');
					form.removeClass('hide');
					form.find('.text').hide();

					var w = window;
					w.google_conversion_id = 1068808087;
					w.google_conversion_label = "H97aCNXk7GQQl-_S_QM";
					w.google_remarketing_only = false;
					goog_report_conversion();
				}
			);
		}
	});

	$('.contact-input .submit').click(function(e)
	{
		e.preventDefault();
		e.stopPropagation();
		var block 	= $(this).parents('.contact-input');
		var pres3 	= block.find('.pres3');
		var form 	= block.find('.footer-contact');
		if(form.find('input[name=contact-phone]').val() != "")
		{
			var data 	= {
				tel: 		form.find('input[name=contact-phone]').val(),
				rappel : 	1
			};

			inscription(
				data, 
				function(retour)
				{
					block.find('.submit').off();
					block.find('.submit').css('backgroundColor', '#00D96D');
					block.find('.submit i').remove();
					block.find('.submit').html('<img src="/img/checked-white.png"/>');

					var w = window;
					w.google_conversion_id = 1068808087;
					w.google_conversion_label = "q26MCLzd7GQQl-_S_QM";
					w.google_remarketing_only = false;
					goog_report_conversion();
				}
			);
		}
	});

	$('.categories .categorie').hover(
		function(e)
		{
			openCateg($(this));	
		},
		function(e)
		{
			closeCateg($(this));
		}
	);

	

	$('.categories .categorie h3 .icon').click(function(e)
	{
		e.stopPropagation();
		if($(this).text() == '+')
			openCateg($(this).parents('categorie'));
		else
			closeCateg($(this).parents('categorie'));
	});
	changeAllLabelInscription();



	$('#myBtnToTop button').click(function()
	{
		$('html,body').animate({scrollTop: 0}, 'slow');
	});




})(jQuery);

function openCateg(categ)
{
	categ.find('.borderBottom').removeClass('hide');
	categ.find('.icon').text('–');
	categ.find('.programmes').animate({
		height: categ.find('.programmes').prop('scrollHeight')+'px'
	}, 500 , 'swing', function(){  });
}
function closeCateg(categ)
{
	categ.find('.programmes').stop();
	categ.find('.programmes').animate(
		{
			height: '0'
		}, 500, 'swing', function()
		{
			categ.find('.borderBottom').addClass('hide');
			categ.find('.icon').text('+');
		}
	);
}

function inscription(datas, cb)
{
	$.cookie.json = true;
	if($.cookie('prospect') != undefined)
	{
		datas.p_id = $.cookie('prospect').id;
		if(datas.prenom == undefined)
			datas.prenom = $.cookie('prospect').prenom;
		if(datas.nom == undefined)
			datas.nom = $.cookie('prospect').nom;
		if(datas.email == undefined)
			datas.email = $.cookie('prospect').email;
		if(datas.tel == undefined)
			datas.tel = $.cookie('prospect').tel;
		if(datas.sessions == undefined)
			datas.sessions = $.cookie('prospect').sessions;
	}
	$.ajax({
		url: '/services/inscription.php',
		type: 'POST',
		dataType: 'json',
		data: datas,
		success: function(retour)
		{
			cb(retour);
		},
		error: function(e)
		{
			console.log("error inscription");
		}
	});
}
function changeAllLabelInscription()
{

}

window.onscroll = function() {scrollFunction()};

function scrollFunction() 
{
	if(document.getElementById("myBtnToTop") != null)
	{
	    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	        document.getElementById("myBtnToTop").style.display = "block";
	    } else {
	        document.getElementById("myBtnToTop").style.display = "none";
	    }
	}
}

